module.exports = __webpack_public_path__ + "bgBanner.png";